export default __webpack_public_path__ + "static/media/Etsy_logo.svg.cdd06fd9.png";